// src/courses/CoursesPage.js
// --- COPIA Y REEMPLAZA TODO EL ARCHIVO ---

import React, { useState, useEffect, useRef } from 'react';
import coursesData from './courses-data.json';
import useScrollReveal from '../utils/useScrollReveal';
import './courses.css';

const CoursesPage = ({ onSelectCourse, onPurchase, onBack }) => {
  const [purchasedCourses, setPurchasedCourses] = useState({});
  const coursesGridRef = useRef(null);
  useScrollReveal(coursesGridRef, '.scroll-reveal');

  useEffect(() => {
    try {
      const storedPurchases = JSON.parse(localStorage.getItem('purchasedCourses')) || {};
      setPurchasedCourses(storedPurchases);
    } catch {
      setPurchasedCourses({});
    }
  }, []);

  // MODIFICADO: Separamos el curso gratuito del resto
  const freeCourse = coursesData.find((c) => c.price === 0);
  const paidCourses = coursesData.filter((c) => c.price > 0);
  const isFreeCoursePurchased = freeCourse && purchasedCourses[freeCourse.id] === true;

  return (
    <div className="page-container">
            <h1 className="page-title">Academia de Tarot Místico</h1>     {' '}
      <p className="page-subtitle">
                Un espacio para profundizar en el lenguaje sagrado de las cartas y despertar tu
        propia         sabiduría interior.      {' '}
      </p>
      {/* --- NUEVA SECCIÓN DESTACADA PARA EL CURSO GRATUITO --- */}
      {freeCourse && (
        <div
          className="value-proposition-container"
          style={{
            borderColor: '#fcd34d',
            background: 'rgba(252, 211, 77, 0.05)',
            textAlign: 'left',
          }}
        >
          <h2 className="value-proposition-title" style={{ textAlign: 'center' }}>
            Comienza Tu Viaje Aquí
          </h2>
          <div style={{ display: 'flex', gap: '2rem', flexWrap: 'wrap', alignItems: 'center' }}>
            <img
              src={freeCourse.coverImage}
              alt={freeCourse.title}
              style={{ width: '200px', borderRadius: '8px', flexShrink: 0 }}
            />
            <div>
              <h3 className="course-card-title" style={{ fontSize: '1.8rem' }}>
                {freeCourse.title}
              </h3>
              <p className="course-card-tagline" style={{ marginBottom: '1.5rem' }}>
                {freeCourse.propuestaDeValor}
              </p>
              {isFreeCoursePurchased ? (
                <button
                  onClick={() => onSelectCourse(freeCourse.id)}
                  className="main-button secondary-button"
                >
                  Continuar Aprendiendo
                </button>
              ) : (
                <button
                  onClick={() => onPurchase(freeCourse)}
                  className="main-button primary-button"
                  style={{ background: 'linear-gradient(to right, #ca8a04, #a16207)' }}
                >
                  Acceder Gratis Ahora
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {/* --- SECCIÓN PARA CURSOS AVANZADOS --- */}
      <div className="spread-category-container" style={{ marginTop: '3rem' }}>
        <h3 className="category-title font-cinzel">Profundiza con Nuestros Cursos Avanzados</h3>
        <div className="courses-grid" ref={coursesGridRef}>
          {paidCourses.map((course) => {
            const isPurchased = purchasedCourses[course.id] === true;
            return (
              <div key={course.id} className="course-card scroll-reveal">
                <div className="course-card-image-container">
                  <img src={course.coverImage} alt={course.title} className="course-card-image" />
                  {isPurchased && <span className="course-card-badge">Adquirido</span>}
                </div>
                <div className="course-card-content">
                  <span className="course-card-level">{course.level}</span>
                  <h3 className="course-card-title">{course.title}</h3>
                  <p className="course-card-tagline">{course.tagline}</p>
                  <div className="course-card-price">
                    {course.price > 0 && (
                      <>
                        <span className="original-price">${course.originalPrice} USD</span>
                        <span className="current-price">${course.price} USD (50% OFF)</span>
                      </>
                    )}
                  </div>
                  {isPurchased ? (
                    <button
                      onClick={() => onSelectCourse(course.id)}
                      className="main-button secondary-button"
                    >
                      Ver Contenido
                    </button>
                  ) : (
                    <button
                      onClick={() => onPurchase(course)}
                      className="main-button primary-button"
                    >
                      Inscribirse Ahora
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
           {' '}
      <button
        onClick={onBack}
        className="main-button secondary-button"
        style={{ marginTop: '3rem' }}
      >
                Volver al Inicio      {' '}
      </button>
         {' '}
    </div>
  );
};

export default CoursesPage;
